import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { RESIZE_THUMB_POSITIONS } from '../../../constants';

const ResizeThumb = ({ position, onPointerDown }) => {
    const ref = useRef();

    return (
        <span
            ref={ref}
            className={classNames('onsolve-wysiwyg-editor__resize-thumb', {
                [`onsolve-wysiwyg-editor__resize-thumb--${position}`]: !!position
            })}
            onPointerDown={e => onPointerDown(e, ref, position)}
        />
    );
};

ResizeThumb.displayName = 'ResizeThumb';

ResizeThumb.propTypes = {
    onPointerDown: PropTypes.func.isRequired,
    position: PropTypes.oneOf(Object.values(RESIZE_THUMB_POSITIONS))
};

export default ResizeThumb;
